import {useTranslation} from 'react-i18next';
import Modal from 'components/Modal';
import incompleteIcon from 'assets/icons/incomplete.svg?no-inline';
import {StyledButton} from './styled';

type Props = {
  open: boolean;
  onClose: () => void;
};

export function ReservationNotFoundModal({open, onClose}: Props) {
  const {t} = useTranslation();

  return (
    <Modal
      title={t('reservation_not_found_modal.title')}
      iconSrc={incompleteIcon}
      iconProps={{width: 67, height: 67}}
      withCloseButton
      maxWidth={600}
      text={
        <>
          {t('reservation_not_found_modal.text')}
          <br />
          <br />
          {t('reservation_not_found_modal.text2')}
        </>
      }
      open={open}
      className="reservation-not-found-modal"
      onClose={onClose}
    >
      <StyledButton onClick={onClose}>{t('ok')}</StyledButton>
    </Modal>
  );
}
